import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./DonationsChart.module.scss";
import { thousandize } from "../../../../util/formatting";
import { Organization } from "../../../../models";
const DonationsChart: React.FC<{
  distribution: {
    org: string;
    sum: number;
  }[];
  organizations: Organization[];
}> = t0 => {
  const $ = _c(12);
  const {
    distribution,
    organizations
  } = t0;
  const total = distribution.reduce(_temp, 0);
  let t1;
  let t2;
  let t3;
  if ($[0] !== distribution || $[1] !== organizations || $[2] !== total) {
    let t4;
    if ($[6] !== distribution) {
      t4 = (a, b) => (distribution.find(d => d.org == b.name)?.sum ?? 0) - (distribution.find(d_0 => d_0.org == a.name)?.sum ?? 0);
      $[6] = distribution;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const sortedOrgs = organizations.sort(t4);
    t1 = style.graph + " " + (distribution.length == 0 ? style.empty : "");
    t2 = "aggregated-donations-distribution-graph";
    t3 = sortedOrgs.map((org, i) => {
      const dist = distribution.find(d_1 => d_1.org == org.name);
      if (!dist) {
        return <div key={i} style={{
          width: "0%",
          borderWidth: "0px",
          zIndex: sortedOrgs.length - i
        }} data-cy="aggregated-donations-distribution-graph-bar"><span>{org.name}</span><span>{"0 kr"}</span></div>;
      }
      return <div key={i} style={{
        width: `${dist.sum / total * 100}%`,
        zIndex: sortedOrgs.length - i
      }} data-cy="aggregated-donations-distribution-graph-bar"><span>{org.name}</span><span>{thousandize(Math.floor(dist.sum)) + " kr"}</span></div>;
    });
    $[0] = distribution;
    $[1] = organizations;
    $[2] = total;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t1} data-cy={t2}>{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default DonationsChart;
function _temp(acc, curr) {
  return acc + curr.sum;
}